export type ScriptTone =
  | 'PROFESSIONAL'
  | 'CASUAL'
  | 'ENERGETIC'
  | 'INFORMATIVE'
  | 'INSPIRATIONAL';

export const SCRIPT_TONE_OPTIONS: {
  value: ScriptTone | null;
  label: string;
  icon: string;
}[] = [
  { value: null, label: 'Select tone...', icon: '' },
  { value: 'PROFESSIONAL', label: 'Professional', icon: 'suitcase' },
  { value: 'CASUAL', label: 'Casual', icon: 'umbrella' },
  { value: 'ENERGETIC', label: 'Energetic', icon: 'volumeup' },
  { value: 'INFORMATIVE', label: 'Informative', icon: 'lightbulb' },
  { value: 'INSPIRATIONAL', label: 'Inspirational', icon: 'favempty' }
];

export interface Shot {
  shotId?: string;
  tempId?: string | number;
  position: number;
  script: string;
  scriptTone: ScriptTone | '';
  description: string;
  assetId: string;
  name?: string;
}

export type ViewMode = 'grid' | 'list';

export interface Asset {
  assetId: string;
  title?: string;
  name?: string;
  metaData?: string;
}

export interface DragHandlers {
  onDragStart: (e: React.DragEvent) => void;
  onDragEnd: (e: React.DragEvent) => void;
}
